import { profileService } from '@/services'

export default {
  state: () => ({
    user: null,
    activeStep: 1
  }),

  getters: {
    isBookInstructionAccepted (state) {
      return state.user?.profile?.showBookOnboarding
    },

    isProjectInstructionAccepted (state) {
      return state.user?.profile?.showProjectOnboarding
    }
  },

  mutations: {
    setUser (state, payload) {
      state.user = payload
    },

    setActiveStepProjectInstructions (state, step) {
      state.activeStep = step
    }
  },

  actions: {
    getProfile ({ commit }) {
      return profileService.profile().then(({ data }) => {
        commit('setUser', data)
        return Promise.resolve(data)
      })
    }
  }
}
